import { ResourceTypeDisplayName } from 'components/pages/entitlement/resource-type/ResourceTypeDisplayName'

export { ResourceTypeDisplayName }
